import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { IChatsSectionProps } from './types';
import { CHATS_TITLE } from '../../constants';
import { ChatsTogglerHOC } from '../../hocs/ChatsTogglerHOC/ChatsTogglerHOC';
import { ChatsHOC } from '../../hocs/ChatsHOC/ChatsHOC';

export function ChatsSection ({
}: IChatsSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--chats';

    return (
        <>
            {/*<TutorialHOC boardSetting={EBoardSetting.LINKS_PREVIEW} />*/}
            <SettingsSection
                className={className}
                title={CHATS_TITLE}
                titleButton={<ChatsTogglerHOC boardId={boardId} />}
            >
                <ChatsHOC boardId={boardId} />
            </SettingsSection>
        </>
    );
};
